
// const featuresImgPathArr = ['./images/feature1.png','./images/feature2.png','./images/feature3.png','./images/feature4.png'];
export const featuresImgPathArr = [
    {
        "id": 1,
        "src": "images/feature1.png",
    },{
        "id": 2,
        "src": "images/feature2.png",
    },{
        "id": 3,
        "src": "images/feature3.png",
    },{
        "id": 4,
        "src": "images/feature4.png",
    }
];




// WEBPACK FOOTER //
// ./src/data/featuresImgPathArr.js